import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import {
  addCoupon,
  getCouponsError,
  getCouponsLoading,
  getCouponsStatus,
  getCouponsSuccess,
  updateStatus,
} from "../../../features/couponSlice";
import { toUtcIsoDateTime } from "../../../global/functions/dateFormat";
import CouponForm from "./couponForm";
import { CouponType, TargetType } from "../../../models/coupon.model";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const AddCoupon = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const status = useSelector(getCouponsStatus);
  const error = useSelector(getCouponsError);
  const loading = useSelector(getCouponsLoading);
  const success = useSelector(getCouponsSuccess);
  const todayCheck = new Date();
  todayCheck.setHours(0, 0, 0, 0);

  const initialValues = {
    code: "",
    couponType: CouponType.fixed,
    couponValue: 0,
    minOrderAmount: 0,
    targetType: TargetType.ALL,
    couponCategories: [],
    couponProducts: [],
    excludeProducts: [],
    recurringDays: [],
    isActive: true,
    startDate: null,
    endDate: null,
    startTime: "",
    endTime: "",
    limit: 0,
  };

  const handleFormSubmit = (values) => {
    let formData = {
      code: values.code,
      couponType: values.couponType,
      couponValue: values.couponValue,
      minOrderAmount: values.minOrderAmount,
      isActive: values.isActive,
      limit: values.limit,
    };

    formData.recurringDays = values.recurringDays || [];

    if (values.startDate && values.startTime) {
      const [startHour, startMinute] = values.startTime.split(":").map(Number);
      formData.startDate = toUtcIsoDateTime(
        values.startDate,
        startHour,
        startMinute
      );
    }

    if (values.endDate && values.endTime) {
      const [endHour, endMinute] = values.endTime.split(":").map(Number);
      formData.endDate = toUtcIsoDateTime(values.endDate, endHour, endMinute);
    }

    if (values.targetType === TargetType.CATEGORIES) {
      formData.categoryType = TargetType.CATEGORIES;
      formData.couponCategories = values.couponCategories;
    } else if (values.targetType === TargetType.PRODUCTS) {
      formData.categoryType = TargetType.PRODUCTS;
      formData.couponProducts = values.couponProducts;
    } else if (values.targetType === TargetType.CATEGORY_PRODUCTS) {
      formData.categoryType = "categories_products";
      formData.couponCategories = values.couponCategories;
      formData.couponProducts = values.couponProducts;
    } else if (values.targetType === TargetType.ALL) {
      formData.categoryType = TargetType.ALL;
    }
    formData.excludeProducts = values.excludeProducts || [];

    dispatch(addCoupon({ body: formData, restaurantId }));
  };

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      navigate("/coupon");
    } else if (status === "addError") {
      toast.error(error);
    }
    dispatch(updateStatus());
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header title={t("headers.addCoupon")} subtitle={t("headers.addCouponSub")} />
      <CouponForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        loading={loading}
      />
    </Box>
  );
};

export default AddCoupon;
